export default function CTA() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20gradient%20abstract%20background%20with%20soft%20coral%20terracotta%20and%20cream%20tones%20blending%20elegantly%2C%20subtle%20organic%20flowing%20shapes%2C%20modern%20luxury%20editorial%20backdrop%2C%20sophisticated%20retail%20atmosphere%2C%20delicate%20warm%20light%20wash%20effect%2C%20serene%20and%20uplifting%20aesthetic%2C%20no%20text%20no%20people&width=1600&height=600&seq=cta-section-v2-2026&orientation=landscape"
          alt="Explore Pandabuy Spreadsheet background"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/40 to-black/55"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white leading-tight">
          Start Exploring the Best Pandabuy Spreadsheet Today
        </h2>
        <p className="mt-4 text-sm md:text-base text-white/80 max-w-lg mx-auto leading-relaxed">
          Join thousands of shoppers who use our spreadsheet to discover verified fashion finds, compare prices,
          and shop smarter every day.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line mr-2"></i>
            Pandabuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-foreground-950 bg-white/90 hover:bg-white rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line mr-2"></i>
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}